// Core
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Styles
// import './styles.scss';

// Assets
import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';
import { Skeleton } from 'antd';
import { Label } from 'assets/styles/globalStyles';
import { FontSizes, FontWeight } from 'utils/enums';
import { colors } from 'assets/styles/colors';
import { motion } from "framer-motion";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Readmore } from 'pages/Homepage/styles';

interface BookData {
    subjectName?: string;
    subjectId?: string;
    name?: string;
    coverImage?: string;
    addinfo?: string;
    bookid?: string;
    authorImage?: string;
    author?: string;
    authorid?: string;
}

interface RootState {
    commonData: {
        currentLang: {
            id: string;
        };
    };
}

const BookView: React.FC = () => {
    const { currentLang } = useSelector((store: RootState) => store.commonData);
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState<BookData | null>(null);
    const { bookId } = useParams<{ bookId: string }>();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const fetchBook = async () => {
        setLoading(true);
        const res = await fetchData(restAPIs.bookInfo(bookId, currentLang?.id));
        setData(res.books[0]);
        setLoading(false);
    };

    useEffect(() => {
        fetchBook();
    }, [currentLang]);

    return (
        <>
            {isLoading ? (
                <div className="container __articles_list" style={{ paddingTop: '20vh', paddingBottom: '6%' }}>
                    <div className="row">
                        <div className='col-md-4 mb-5'>
                            <Skeleton.Image active style={{ width: '300px', height: '400px' }} />
                        </div>
                        <div className='col-md-8'>
                            <Skeleton active paragraph={{ rows: 5 }} />
                        </div>
                    </div>
                </div>
            ) : (
                <div className='container'>
                    <div className='row'>
                        <motion.div
                            className='col-md-4 mb-5'
                            initial={{ opacity: 0, x: -50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5 }}
                        >
                            <img
                                className="__cover_im_book imageLoader"
                                src={data?.coverImage}
                                alt={data?.name}
                                style={{
                                    objectFit: 'cover',
                                    borderRadius: '10px',
                                    minHeight: '400px',
                                    backgroundColor: '#E5E5E5',
                                    width: '100%',
                                }}
                            />
                            <motion.div
                                className='mt-5 d-flex align-items-start flex-column justify-content-center text-center'
                                style={{ gap: '10px', }}
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5 }}
                            >
                                <img
                                    className="imageLoader"
                                    src={data?.authorImage}
                                    alt={data?.author}
                                    style={{
                                        width: '150px',
                                        height: '170px',
                                        objectFit: 'cover',
                                        borderRadius: '10px',
                                        margin: '0 auto',
                                    }}
                                    onClick={() => window.open('https://alwaraq.net/books/author/' + data?.authorid, '_blank', 'noopener,noreferrer')}
                                />
                                <a
                                    href={'https://alwaraq.net/books/author/' + data?.authorid}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ margin: '0 auto' }}
                                >
                                    {data?.author}
                                </a>
                            </motion.div>
                        </motion.div>
                        <div className='col-md-8'>

                            <motion.div
                                className='mb-5 d-flex flex-column'
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5 }}
                            >
                                <Label className="fade-left" pointer fontSize={FontSizes.h3} onClick={() => navigate(-1)} fontWeight={FontWeight.bold} marginTop={3} marginBottom={10}><ArrowLeftOutlined /> Back</Label>
                                <Label className="fade-left" fontSize={FontSizes.h1} fontWeight={FontWeight.bold} marginTop={0} marginBottom={5}>{data?.name}</Label>
                                <Label className="fade-left" color={colors.secondary} fontSize={FontSizes.h2} fontWeight={FontWeight.bold} marginTop={0} marginBottom={5} pointer><a href={`https://alwaraq.net/books-under/${data?.subjectName}/${data?.subjectId}`} rel="noreferrer" target='_blank' >{data?.subjectName}</a></Label>
                            </motion.div>
                            <motion.div
                                className='mb-5 d-flex flex-column'
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5 }}
                                style={{ textAlign: 'justify', lineHeight: '2', fontSize: '16px' }}
                                dangerouslySetInnerHTML={{ __html: data?.addinfo || '' }}
                            ></motion.div>
                            <motion.div
                                className='mb-5'
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5 }}
                            >
                                <Readmore
                                    href={'https://alwaraq.net/books/' + data?.bookid}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t('learn_more')}

                                </Readmore>
                            </motion.div>

                        </div>
                    </div>
                </div>
            )
            }

        </>
    );
};

export default BookView;
